module.exports = __webpack_public_path__ + "img/livelo.ae5d2594.svg";